module.exports = __webpack_public_path__ + "img/wximg25.4a60c28d.png";